import helper from "../lib/helper_lib";

export default class ProfileActions {
  constructor(el) {
    this.el = el;
    this.favToggle = this.el.querySelectorAll(".favorite-toggle");
    this.addContactButton = this.el.querySelectorAll("#addContact");

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.favoriteToggle();
    this.sendSmile();
    this.addContact();
    this.ConfirmContact();
  }

  sendSmile() {
    $("body").on("click", "#sendSmile", usr => {
      const myObj =
        usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;

      const partnerId = encodeURIComponent(myObj.getAttribute("data-uid"));
      const success = (r) => {
        let disableButton = true;
        if (disableButton) {
          myObj.setAttribute("disabled", "disabled");
          setTimeout(() => {
            target.removeAttribute("disabled");
            disableButton = false;
          }, 30000);
        }
        if (r.status !== "undefined" && r.status == 200) {
          helper.showMessage(
            "info",
            "#message-box",
            "",
            i8n.Send_send_ok,
            10000
          );
        } else if (typeof r.status !== "undefined" && r.status == 429) {
          helper.showMessage(
            "error",
            "#message-box",
            "",
            i8n.error.Visitor_tofast,
            20000
          );
        }
        else {
          helper.showMessage(
            "error",
            "#message-box",
            "",
            i8n.error.Bulkpost_error,
            10000
          );
        }
      }

      helper.standardMessage(myObj, "SMILE", partnerId, success)
    });
  }

  addContact() {
    $("body").on("click", "#addContact", usr => {
      const myObj =
        usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;
      const partnerId = myObj.getAttribute("data-uid");

      let action = "contactRequest";

      const success = (r) => {
        if (r.status !== "undefined" && r.status == 200) {

          $("#addContact")
            .removeClass("fa-user-plus fa-user")
            .addClass("fa-user-o");
          $("#addContact").attr(
            "data-content",
            $("#addContact").attr("data-title-requested")
          );

          helper.showMessage(
            response.type,
            "#message-box",
            "",
            response.message,
            10000
          );
        } else {
          helper.showMessage(
            "error",
            "#message-box",
            "",
            i8n.error.Bulkpost_error,
            10000
          );
        }
      }

      helper.standardMessage(myObj, action, partnerId, success)
    });
  }

  ConfirmContact() {
    $("body").on("click", "#ConfirmContactProfil", usr => {
      const myObj =
        usr.target.nodeName === "I" ? usr.target.parentElement : usr.target;
      const userid = myObj.getAttribute("data-uid");
      const data = {};
      data.id = userid;

      data.adduser = userid;
      data.mode = "ConfirmContactProfil";
      data.ras = "g";

      $.ajax({
        url: helper.getCacheBustedLink("/", "ajax", "php"),
        method: "POST",
        data,
        success: response => {
          $("#addContact")
            .removeClass("fa-user-plus fa-user-o")
            .addClass("fa-user");
          $("#addContact").attr(
            "data-content",
            $("#addContact").attr("data-title-accepted")
          );
          helper.showMessage(
            response.type,
            "#message-box",
            "",
            response.message,
            10000
          );
        }
      });
    });
  }

  favoriteToggle() {
    this.favToggle.forEach(toggle => {
      const userid = toggle.dataset.id;
      toggle.addEventListener("click", () => {
        const data = {
          id: userid,
          act: 1,
          mode: "favsave"
        };
        $.ajax({
          url: helper.getCacheBustedLink("/", "ajax", "php"),
          method: "POST",
          type: "html",
          data,
          success: response => {
            helper.showMessage(
              response.type,
              "#message-box",
              "",
              response.message,
              10000
            );
            const iObj = $(`#fav-i-${userid}`);
            switch (response.action) {
              case "i":
                iObj
                  .find("i")
                  .removeClass("fa-bookmark-o")
                  .addClass("fa-bookmark");
                iObj.attr("data-content", iObj.data("title-remove"));
                break;
              case "r":
                iObj
                  .find("i")
                  .removeClass("fa-bookmark")
                  .addClass("fa-bookmark-o");
                iObj.attr("data-content", iObj.data("title-add"));
                break;
              // no default
            }
            return true;
          }
        });
      });
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/profile_actions.js